import { combineReducers } from 'redux';
import data from './user';

const user = combineReducers({
  data,
});

export default user;
